var map = {
	"./disaster_type/ico__earth_and_sand.svg": 1403,
	"./disaster_type/ico__earthquake.svg": 763,
	"./disaster_type/ico__eruption.svg": 3328,
	"./disaster_type/ico__fire.svg": 5696,
	"./disaster_type/ico__flood.svg": 1800,
	"./disaster_type/ico__internal_water.svg": 8867,
	"./disaster_type/ico__storm_surge.svg": 9900,
	"./disaster_type/ico__tsunami.svg": 369,
	"./facility_type/ico__christianchurch.svg": 986,
	"./facility_type/ico__facilityOther.svg": 901,
	"./facility_type/ico__otherreligious.svg": 9249,
	"./facility_type/ico__park.svg": 346,
	"./facility_type/ico__publichall.svg": 4100,
	"./facility_type/ico__school.svg": 2958,
	"./facility_type/ico__shrine.svg": 1067,
	"./facility_type/ico__temple.svg": 4597,
	"./hamekomi.jpg": 8300,
	"./ico__evacuationother.svg": 9918,
	"./ico__locked__white.svg": 1719,
	"./ico__otherreligious.svg": 5642,
	"./ico__provisional.svg": 1685,
	"./ico__shelter.svg": 7988,
	"./ico__welfare.svg": 4875,
	"./ico__wide.svg": 8444,
	"./shelter_type/ico__assignment.svg": 417,
	"./shelter_type/ico__emergency.svg": 2013,
	"./shelter_type/ico__emergency_and_assignment.svg": 8365,
	"./shelter_type/ico__etc.svg": 5292,
	"./shelter_type/ico__other.svg": 5380,
	"./shelter_type/ico__provisional.svg": 6260,
	"./shelter_type/ico__welfare.svg": 3602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6190;